import clsx from 'clsx';
import type { LoadingProps } from '../Loading/Loading';
import { Loading } from '../Loading/Loading';

export function LoadingOverlay({
  size = 'medium',
  variant = 'primary',
  ...props
}: LoadingProps): JSX.Element {
  const background = variant === 'primary' ? 'bg-white/50' : 'bg-black/50';
  return (
    <div
      className={clsx(
        'absolute z-10 h-full w-full select-none overflow-visible',
        background,
      )}
    >
      <div className='h-screen w-screen'>
        <Loading size={size} variant={variant} {...props} />
      </div>
    </div>
  );
}
